import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useLanguageStore } from '~/stores/language'
import { copyFor, elementLocaleFor, translate } from '~/locales'

/**
 * The app's single entry point for language. Components read `t` and bind
 * `elementLocale` to `<el-config-provider :locale>`. Nothing else assembles a
 * locale object.
 *
 * `computed` is not optional: `elementLocale` must re-resolve when the
 * language changes, or Element Plus keeps the old library strings.
 */
export function useLocale() {
  const { language } = storeToRefs(useLanguageStore())

  const copy = computed(() => copyFor(language.value))

  function t(path, fallback = '') {
    return translate(copy.value, path, fallback)
  }

  const elementLocale = computed(() => elementLocaleFor(language.value))

  return {
    language,
    copy,
    t,
    elementLocale,
  }
}
